import Alert from '@mui/material/Alert';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import {
  MARKET_OPERATOR_RESTRICTION_REASON,
  type MarketOperatorRestrictionReason,
} from '../../../../utils/marketOperatorRestrictions';

export type MarketOperatorRestrictionAlertProps = {
  reason: MarketOperatorRestrictionReason;
};

export const getMarketOperatorRestrictionMessage = (reason: MarketOperatorRestrictionReason, t: TFunction): string =>
  reason === MARKET_OPERATOR_RESTRICTION_REASON.CROSS_REGION
    ? t("Cross-Region targeting doesn't allow for Intersection criteria.")
    : t("Sellable multipartner (Data Marketplace) segments on non-US markets don't allow intersection between groups.");

export const MarketOperatorRestrictionAlert = ({ reason }: MarketOperatorRestrictionAlertProps) => {
  const { t } = useTranslation();

  const message = getMarketOperatorRestrictionMessage(reason, t);

  return (
    <Alert severity="info" sx={{ maxWidth: 720 }} data-test="market-operator-restriction-alert">
      {message}
    </Alert>
  );
};
